/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

export const customTheme = theme => ({
  root: {
    backgroundColor: theme.palette.contrastBackground,
    position: 'static',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
  },
  responsive: {
    display: 'block',
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  visuallyHidden: {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 'calc(1rem / 16)',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: 'calc(1rem / 16)',
  },
  content: {
    paddingTop: '1.5rem',
    paddingBottom: '1rem',
  },
  hidden: {
    display: 'none',
  },
});
